module.exports = __webpack_public_path__ + "img/AI Icon.2c818178.svg";